import Swal from "sweetalert2";
import Auth from "../middleware/auth";
import { Divider, notification } from "antd";
import { ReactComponent as NotificationBell } from "../../assets/svg/Notification.svg";
import { ReactComponent as CloseIcon } from "../../assets/svg/Icons/Close.svg";
export const Toast = Swal.mixin({
	toast: true,
	position: "top",
	showConfirmButton: false,
	iconColor: "white",
	customClass: {
		popup: "colored-toast",
	},
	timer: 3000,
	timerProgressBar: true,
});

export const numberFormat = (value) => {
	new Intl.NumberFormat().format(!isNaN(value) && value);
};

export const validatePhone = (phoneNumber) => {
	// alert(phoneNumber)
	let phone = phoneNumber;
	if (phone.length < 11) {
		return false;
	}
	// eslint-disable-next-line
	if (phone[0] != 0 && phone[0] != "+") {
		return false;
	}
	// eslint-disable-next-line
	if (phone[0] == 0) {
		phone = phone.replace("0", "+234");
		//phone = '+234' + phone;
	}
	// eslint-disable-next-line
	if (phone.trim().startsWith("+234")) {
		// eslint-disable-next-line
		if (phone[4] == "0") {
			phone = phone.replace("0", "");
		}
	}
	return phone.replace(/ +/g, "");
};

export const ValidateEmail = (mail) => {
	if (
		/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
			mail
		)
	) {
		return true;
	}
	console.log("You have entered an invalid email address!");
	return false;
};

export const isEmpty = (value) =>
	value === undefined ||
	value === null ||
	(typeof value === "object" && Object.keys(value).length === 0) ||
	(typeof value === "string" && value.trim().length === 0);

export const truncate = (s, n) => {
	return s.length > n ? s.substr(0, n - 1) + "..." : s;
};

export const defaultCurrency = {
	code: "NGN",
	createdAt: "2021-11-23T19:21:54.258Z",
	id: 1,
	name: "naira",
	symbol: "U+20A6",
};

export const currencySymbol = () => {
	const user = Auth?.getUser();
	const currency = Auth.getCurrency();
	let symbol;
	if (
		!Auth.isAuthenticated() &&
		(currency === null || currency === undefined)
	) {
		Auth.setCurrency(defaultCurrency);
		return defaultCurrency.symbol;
	} else if (
		Auth.isAuthenticated() &&
		(currency === null || currency === undefined)
	) {
		symbol = user?.currency?.symbol;
	} else {
		const code = Auth.getCurrency();
		symbol = code?.symbol;
	}
	return symbol?.split("+").pop();
};

export const currencyFormat = (str) => {
	// 	const strz =
	// 		(str !== undefined && str !== "" && str !== 0) ? str.toString() : str = "0";
	// 	return strz.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	// };
	const strz =
		str !== undefined && str !== "" && str !== 0
			? str.toString()
			: (str = "0");
	return new Intl.NumberFormat().format(strz);
};

export function imgToBase64(imgUrl) {
	const fallbackString = () => {
		var img = new Image();
		img.src = imgUrl;
		img.setAttribute("crossOrigin", "anonymous");
		var canvas = document.createElement("canvas");
		canvas.width = img.width;
		canvas.height = img.height;
		var ctx = canvas.getContext("2d");
		ctx.drawImage(img, 0, 0);
		var dataURL = canvas.toDataURL("image/png");
		// return dataURL
		return dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
	};
	return fallbackString();
}

export const getBase64 = (file) =>
	new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.readAsDataURL(file);

		reader.onload = () => resolve(reader.result);

		reader.onerror = (error) => reject(error);
	});

export const fallbackString = (val) => {
	return imgToBase64(val);
};

export const customNotification = ({ title, description }) => {
	notification.open({
		icon: <NotificationBell />,
		closeIcon: <CloseIcon />,
		message: <h3 tw="text-appPink font-bold text-base">{title}</h3>,
		description: (
			<>
				<Divider tw="m-0! mb-2! w-full!" />
				<div>{description}</div>
			</>
		),
		className: "custom-class",
		style: {
			borderRadius: "10px",
			backgroundColor: "#FFEAED",
		},
		bottom: 0,
	});
};

export const onlyNumberInput = (evt) => {
	// Only ASCII character in that range allowed
	var ASCIICode = evt.which ? evt.which : evt.keyCode;
	if (ASCIICode > 31 && (ASCIICode < 48 || ASCIICode > 57)) return false;
	return true;
};
